export const tabsModalStart =() => {
// Tabs
    function TabContainer(element) {
        this.root = element;
        this.tabLinks = this.root.querySelectorAll('.tabs__tab');
        this.wrapper = this.root.querySelector('.tabs__wrapper');
        this.activeLink = 0;
        this.tabLinks[this.activeLink].classList.add('active');

        for (let i = 0; i < this.tabLinks.length; i++) {
            let link = this.tabLinks[i];
            link.addEventListener('click', this.setClickedTab.bind(this));
        }
    }
    TabContainer.prototype.setClickedTab = function(e){
        this.removeActive();
        let clickedTab = e.target;
        this.activeLink = clickedTab.itemID;
        this.changePosition(clickedTab);
    };
    TabContainer.prototype.changePosition = function(link) {
        link.classList.add('active');
        this.wrapper.style.left = (link.getAttribute('data-id') - 1) * -100 + '%';
        const content = document.getElementsByClassName('tabs__content');

        for (let i = 0; i < content.length; i++) {
            if(content[i].getAttribute('data-id') !== link.getAttribute('data-id')){
                content[i].style.height = '0';
            } else {
                content[i].style.height = 'auto';
            }
        }
    };
    TabContainer.prototype.removeActive = function() {
        for (let i = 0; i < this.tabLinks.length; i++) {
            this.tabLinks[i].classList.remove('active');
        }
    };
    let tabContainers = document.querySelectorAll('.tabs');
    Array.prototype.forEach.call(tabContainers, function(element){
        element.setAttribute('data-controller', new TabContainer(element));
    });

// Modals
    const modals = document.querySelectorAll("[data-modal]");
    modals.forEach(function (trigger) {
        trigger.addEventListener("click", function (event) {
            event.preventDefault();
            const modal = document.getElementById(trigger.dataset.modal);
            modal.classList.add("open");
            document.body.classList.add("no-scroll");

            const exits = modal.querySelectorAll(".modal-exit");
            exits.forEach(function (exit) {
                exit.addEventListener("click", function (event) {
                    event.preventDefault();
                    modal.classList.remove("open");
                    document.body.classList.remove("no-scroll");
                });
            });
        });
    });

};